module.exports = __webpack_public_path__ + "static/media/btbms-dt-en.0f0434ad.jpg";